import { create } from "zustand";

export interface AuthUser {
  id: number;
  email: string;
  userName: string | null;
  role: "admin" | "user";
  picture: string | null;
  status: "invited" | "active";
  lastLoginAt: string | null;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  setAuth: (data: { accessToken: string; user?: AuthUser }) => void;
  setUser: (user: AuthUser) => void;
  clear: () => void;
}

// Auth state is kept in memory only — never persisted to localStorage/sessionStorage.
// Storing the access token in web storage exposes it to XSS; instead the session is
// re-established on reload via the httpOnly `refresh_token` cookie (silent refresh in
// api-client.ts, triggered by admin.tsx's clientLoader calling authApi.me()).
export const useAuthStore = create<AuthState>()((set) => ({
  accessToken: null,
  user: null,
  setAuth: ({ accessToken, user }) => set((state) => ({ accessToken, user: user ?? state.user })),
  setUser: (user) => set({ user }),
  clear: () => set({ accessToken: null, user: null }),
}));
